<ng-container
  *ngLet="{
    _mobile:
      settingsService.screenBreakpoint$ | async | appScreenLessThan: BreakpointTypeEnum.XSmall,
    _tab:
      settingsService.screenBreakpoint$ | async | appScreenLessThan: BreakpointTypeEnum.HalfSmall,
    showSidebar: currentUrl.startsWith('/configurator')
  } as obj"
>
  <app-main-header></app-main-header>
  <app-main-sidebar *ngIf="obj.showSidebar"></app-main-sidebar>

  <app-toast></app-toast>

  <div
    class="app-layout"
    [class.app-layout--mobile]="obj._mobile"
    [class.app-layout--with-sidebar]="!obj._tab && obj.showSidebar"
    [class.app-layout--sidebar-collapsed]="
      !obj._tab && obj.showSidebar && (mainSidebarState.collapsed$ | async)
    "
  >
    <router-outlet></router-outlet>
  </div>
</ng-container>
